import React from 'react';
import { happyHourConfig } from '../../data/happyHourConfig';
import './HappyHourBadge.css';

const HappyHourBadge = ({ size = 'schooner', show = true }) => {
  // Check if current time is within happy hour
  const isHappyHour = () => {
    const now = new Date();
    const currentDay = now.toLocaleDateString('en-AU', { weekday: 'lowercase' });
    const currentTime = now.toLocaleTimeString('en-AU', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit' 
    });

    const isHappyHourDay = happyHourConfig.schedule.days.includes(currentDay);
    const isHappyHourTime = currentTime >= happyHourConfig.schedule.startTime && 
                           currentTime <= happyHourConfig.schedule.endTime;

    return isHappyHourDay && isHappyHourTime;
  };

  // Don't show badge if not applicable for this size
  if (!happyHourConfig.applicableSizes.includes(size)) {
    return null;
  }

  // Don't show badge if not in happy hour period and show is based on current time
  if (!show && !isHappyHour()) {
    return null;
  }

  if (!happyHourConfig.display.showBadge) {
    return null;
  }

  return (
    <div className="happy-hour-badge">
      <span className="happy-hour-badge__text">
        {happyHourConfig.offer.badge}
      </span>
      <span className="happy-hour-badge__offer">
        {happyHourConfig.offer.type}
      </span>
    </div>
  );
};

export default HappyHourBadge;